import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import folioCollectionComponent from './folioCollection.component';

const folioCollectionModule = angular
  .module('folioCollection', [uiRouter])

  .config(($stateProvider) => {
    'ngInject';

    $stateProvider.state('index.artist.folioCollection', {
      url: '/collection/{folioCollectionSlug:[0-9a-zA-Z_-]{1,200}}',
      reloadOnSearch: false,
      resolve: {
        folioCollection: ($state, $stateParams, $q, ApiService) =>
          // const folioCollection = artist.fields.folios.filter((folioCollection) => {
          //   return folioCollection.slug === $stateParams.folioCollectionSlug;
          // })[0];

          // if (folioCollection) {
          //   return $q.resolve(folioCollection);
          // }

          ApiService.entitySearchOne({
            q: `schema:folioCollection AND slug:"${$stateParams.folioCollectionSlug}" AND fields.artist.slug:${$stateParams.artistSlug}`,
            children: 1,
          }).then((folioCollection) => {
            if (Object.keys(folioCollection).length === 0) {
              // throw new Error('Collection not found');
              $state.go('notFound');
              return;
            }
            return folioCollection;
          }),
      },
      views: {
        'content@index': {
          component: 'folioCollection',
        },
      },
    });
  })

  .component('folioCollection', folioCollectionComponent);

export default folioCollectionModule;
